import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import xlsx from "xlsx";
import ClientService from '../../../clientmanagement/services/clientmanagement.service';
import TripServices from '../../services/firstAndLastmilemanagement.service';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import Multiselect from 'vue-multiselect';
import Loader from '../../../shared/components/loader'
import Util from '../../../shared/util/util'
import XLSX from 'xlsx';
const moment = require('moment');
const aws = require('aws-sdk')

aws.config.update({
    secretAccessKey: 'AKIAYDGGCIIFBPPHHGN4',
    accessKeyId: 'DvFNvaDmNRe2BiYIvDsrYeoPoAoaz1QnuE9g2dbw',
})

const s3 = new aws.S3({
    region: 'ap-south-1',
})

export default {
    name: 'BulkReviewFtcDeposit',
    props:['filterPaylod'],
    components: {
        VueElementLoading,
        Treeselect,
        Loader,
        Multiselect
    },
    data: function () {
        return {
            isLoading: false,
            filename: "",
            val: 0,
            progress: 0,
            client: null,
            clientid: '',
            businessaccountname: '',
            clientbusinessdetailid: '',
            clientbusinessaccountid: '',
            SKUData: [],
            SKUlist: [],
            ClientUOM: "",
            activecontract: "",
            totalRecords: 0,
            successRecords: 0,
            failedRecords: {},
            showresult: false,
            disabled: false,
            FailedResultModal: false,
            disableclientselection: false,
            compNameArr: [],
            uomArr: [],
            manifestMethods: [],
            boxtypelist: [],
            clientFileType: 3,
            filesource: "../static/FTC_Finance_Review_Report _Bulk.xlsx",
            showuploadresult: false,
            uploadResultData: [],
            importResultData: [],
            showimportbutton: false,
            showimportresult: false,
            batchsizeforimport: 0,
            validrecordsforimport: 0,
            Clientlist: [],
            userName: "",
            fileid: 0,
            file: null,
            stepOne: false,
            stepTwo: false,
            stepThree: false,
            progressarr: ['stop', 'stop', 'stop', 'stop'],
            totaldata: 0,
            validateddata: 0,
            validdateddatalist: [],
            limit: 10,
            showprogress: false,
            isEditing: false,
            showSpinner: false,
            clientErr: false,
            disableimport: false,
            offset: 0,
            toggleActive: true,
            validRecordCount: 0,
            invalidRecordCount: 0,
            downloadTemplateMessage: "",
            activeStep_1: true,
            activeStep_2: false,
            activeStep_3: false,
            activeStep_4: false,
            activeStep_Zoom_1 : true,
            activeStep_Zoom_2 : false,
            activeStep_Zoom_3 : false,
            activeStep_Zoom_4: false,
            stepText_1 : 'Processing',
            stepText_2 : 'Not Started',
            stepText_3 : 'Not Started',
            stepText_4: 'Not Started',
            showFullScreen: true,
            activeDiv: 1
        }
    },
    beforeMount() {
        window.addEventListener("beforeunload", this.preventNavigation)
        this.$once("hook:beforeDestroy", () => {
          window.removeEventListener("beforeunload", this.this.preventNavigation);
        })
      },    
      beforeRouteLeave(to, from, next) {
        if (this.isEditing) {
          if (!window.confirm("Leave without saving?")) {
            return;
          }
        }
        next();
      },
      async beforeDestroy() {
        this.isEditing= false;
    },
    computed: {
    },
    mounted() {
        var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.userName = userdetail.email;
        this.getCompanyShortName();
        // this.progressBar()
    },
    methods: {
        toggleDiv() {
            this.activeDiv = this.activeDiv === 1 ? 2 : 1;
          },
        resizeColumns() {
            this.showFullScreen = false;
          },
        setup() {
            const active = ref(false);
        
            const toggleActive = () => {
              active.value = !active.value;
            };        
            return { active, toggleActive };
          },
        preventNavigation(event) {
            if (!this.isEditing) return
            event.preventDefault()
            event.returnValue = ""
          },
        async getCompanyShortName() {
            try {
                let InputPayload = {}
                var CompanyShortList = [];
                let result = await ClientService.GetClientListByActiveContracts(InputPayload);
                CompanyShortList = result.data.data.rows;
                let tempArr = [];
                for (var i = 0; i < CompanyShortList.length; i++) {
                    tempArr.push({
                        'id': CompanyShortList[i].clientbusinessaccountid,
                        'label': CompanyShortList[i].clientshortname,
                        'ContractId': CompanyShortList[i].id,
                        'CompanyName': CompanyShortList[i].clientcompanyname,
                        'ClientId': CompanyShortList[i].clientid,
                        'ClientBusinessAccountId': CompanyShortList[i].clientbusinessaccountid,
                        'ClientBusinessDetailId': CompanyShortList[i].clientbusinessdetailid,
                    });
                }
                this.Clientlist = tempArr.filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i);
            } catch (err) {
                console.log(err);
            }
        },
        async uploadBookingData(e) {
            if (!/\.(xls|xlsx)$/.test(e.target.files[0].name.toLowerCase())) {
                this.isLoading = false;
                this.$refs.files.value=null;
                return this.$alert('The upload format is incorrect. Please download template for correct format', "", "error");
            }
            this.filename = e.target.files[0].name;
            this.showprogress = true;
            const files = e.target.files;
            this.file = e.target.files[0]
            this.isLoading = false;
            // var reader = new FileReader()
            // reader.readAsDataURL(e.target.files[0])
            // let binaryfile = ''
            // reader.onload = async () => {
            //     binaryfile = reader.result
            //     let result = await this.singleUpload(files[0], 'BookingSoftUpload', reader.result)
            //     this.isLoading = false;
            //     console.log("result => ", result)

            // };
            // console.log(binaryfile);
        },
        async uploadFile(file) {
            try {
                let formData = new FormData();
                formData.append('file', file);
                formData.append('lastmodifiedby', this.userName);
                let result = await TripServices.uploadFinanceFtcCSVFile(formData);
                if (result.data.code == 200) {
                    this.fileid = result.data.data.fileid
                    this.totaldata = result.data.data.totaldata;
                    return true
                } else {
                    let messageString = `<br>
                    <i class="fa fa-exclamation-triangle fa-4x" aria-hidden="true" style="color: #f0986e;"></i><br>
                    <h5 style="color: #e65712;">Oops! Something went wrong during the file upload</h5><br>
                    <div style="text-align:left">                    
                    <h6><strong>Possible reasons for failure</strong></h6>
                    <ul style="font-size: 16px">
                    <li>Ensure that your file is in the correct CSV Format.</li>
                    <li>Verify that your CSV file contains valid and complete data.</li>
                    </ul>                    
                    <p style="font-size: 17px">We apologize for any inconvenience.</p></div>
                    `
                      this.$fire({
                        icon: "success",
                         html: messageString,
                         width: 500,
                         textalign: 'center',          
                         reverseButtons: false,
                         showCancelButton: false,
                         confirmButtonColor: '#009C41',
                         confirmButtonText: '<i class="fa fa-thumbs-up"></i> Ok'        
                         })      
                    this.resetform()
                    return false
                }
            } catch (err) {
                console.log(err);
            }
        },
        singleUpload(file, folder, binaryfile) {
            try {
                const key = folder + '/' + Date.now() + '-' + file.name.replace(/\s/g, '-')
                const params = {
                    Bucket: 'stage-b2bmarketplace',
                    Key: key,
                    Expires: 20,
                    ContentType: file.type,
                }
                const url = s3.getSignedUrl('putObject', params)
                console.log(url);
                return axios
                    .put(url, binaryfile, {
                        headers: {
                            'Content-Type': file.type,
                        },
                    })
                    .then(result => {
                        console.log(result);
                        const bucketUrl = decodeURIComponent(result.request.responseURL).split(
                            key
                        )[0]
                        result.key = key
                        result.fullPath = bucketUrl + key
                        return result
                    })
                    .catch(err => {
                        // TODO: error handling
                        console.log(err)
                    })
            } catch (error) {
                console.log("Error occured", error);
            }
        },
        async validate(fileid, norecord) {
            try {
                let input = {
                    fileid: fileid,
                    limit: norecord,
                    lastmodifiedby: this.userName,
                    offset: this.offset
                }
                let result = await TripServices.validateFinanceReviewCsvFile(input)
                if (result.data.code == 200) {
                    this.validateddata = norecord + this.offset;
                    this.offset = this.offset + this.limit;
                    this.validdateddatalist.push(...result.data.data)
                    return result.data.data;
                }
            } catch (err) {
                console.log(err);
            }
        },
        groupBy(array, property) {
            var hash = {};
            for (var i = 0; i < array.length; i++) {
                if (!hash[array[i][property]]) {
                    hash[array[i][property]] = []
                };
                hash[array[i][property]].push(array[i]);
            }
            return hash;
        },
        openUploadResultData(type) {
            this.showuploadresult = false;
            this.uploadResultData = null;
            this.showimportbutton = false;
            if (type == 'valid') {
                this.uploadResultData = this.successRecords;
                this.showimportresult = false;
                if (this.successRecords.length > 0 || this.importResultData.length != this.successRecords.length) {
                    this.showuploadresult = true;
                    this.showimportbutton = true;
                }
            } else if (type == 'invalid') {
                this.showimportresult = false;
                this.showimportbutton = false;
                this.uploadResultData = this.failedRecords;
                if (this.uploadResultData && this.uploadResultData.length >0) {
                    this.showuploadresult = true;
                }
            }
        },
        async importValidRecords() {
            try{
                this.$set(this.progressarr, 2 , 'start')
                this.showSpinner=true;
                this.disableimport=true;
                let input = {
                    fileid: this.fileid
                }
                let result = await TripServices.ftcSettlementSaveCSVData(input);
                if (result.data.code == 200) {
                    this.markStep3Done()
                    this.$set(this.progressarr, 2 , 'complete')
                    this.$set(this.progressarr, 3 , 'complete')
                    this.isEditing = false;
                    this.disableimport = true;
                    this.showSpinner=false;
                    this.$alert(result.data.message, "", "success");
                } else {
                    this.$alert(result.data.message, "", "error");
                }
            } catch ( err){
                console.log(err);
            }
        },
        downloadFile() {
            try {
                let downloadArr = [];
                if (this.uploadResultData) {
                    downloadArr = this.uploadResultData.map((el) => {
                        return {
                            "Pickup Pincode": el.pickuppincode,
                            "Destination Pincode": el.destinationpincode,
                            "Route Mode": el.routemode,
                            "Pickup Location": el.pickuplocation,
                            "Pickup Address": el.pickupaddress1,
                            "Contact Name": el.contactname,
                            "Contact Number": el.mobile,
                            "Alternate Contact Number": el.alternatemobile,
                            "Email": el.pickupemail,
                            "Number of Boxes": el.numberofmps,
                            "Physical Weight(KG)": el.totalwt,
                            "Requested Pickup date MM/DD/YYYY": el.requestedpickupdate ? Util.displayDateOnlyFormat(el.requestedpickupdate): "",
                            "GST No": el.pickupgst,
                            "Message": el.comment,
                        }
                    });
                    var filename='InvalidRecords.xlsx';
                    var ws = xlsx.utils.json_to_sheet(downloadArr);
                    var wb = xlsx.utils.book_new();
                    xlsx.utils.book_append_sheet(wb, ws, "Sheet1");
                    xlsx.writeFile(wb,filename);
                } else {
                    const data = xlsx.utils.json_to_sheet(downloadArr);
                    const wb = xlsx.utils.book_new();
                    xlsx.utils.book_append_sheet(wb, data, 'data')
                    xlsx.writeFile(wb, 'InvalidRecords.xlsx');
                }
            } catch (err) {
                console.log(err);
            }
        },
        async selectClient(data) {
            this.resetform();
            if (data) {
                this.activecontract = data.ContractId;
                this.clientid = data.ClientId;
                this.businessaccountname = data.CompanyName;
                this.clientbusinessdetailid = data.ClientBusinessDetailId;
                this.clientbusinessaccountid = data.ClientBusinessAccountId;
                this.disableclientselection = true;
            }
        },
        resetform() {
            this.filename = "";
            this.val = 0;
            this.progress = 0;
            this.client = null;
            this.clientid = '';
            this.businessaccountname = '';
            this.clientbusinessdetailid = '';
            this.clientbusinessaccountid = '';
            this.SKUData = [];
            this.SKUlist = [];
            this.ClientUOM = "";
            this.activecontract = "";
            this.totalRecords = 0;
            this.successRecords = 0;
            this.failedRecords = {};
            this.showresult = false;
            this.disabled = false;
            this.FailedResultModal = false;
            this.disableclientselection = false;
            this.compNameArr = [];
            this.uomArr = [];
            this.manifestMethods = [];
            this.boxtypelist = [];
            this.clientFileType = 3;
            this.showuploadresult = false;
            this.uploadResultData = [];
            this.importResultData = [];
            this.showimportbutton = false;
            this.showimportresult = false;
            this.batchsizeforimport = 0;
            this.validrecordsforimport = 0;
            this.fileid = 0;
            this.file = null;
            this.stepOne = false;
            this.stepTwo = false;
            this.stepThree = false;
            this.progressarr = ['stop', 'stop', 'stop', 'stop'];
            this.totaldata = 0;
            this.validateddata = 0;
            this.validdateddatalist = [];
            this.limit = 10;
            this.showprogress = false;
            this.offset = 0
            this.$validator.reset();
            this.isEditing = false;
            this.showSpinner = false;
            this.$refs.files.value=null;
            this.clientErr = false;
            this.progressValue = 0
            this.resetToFirst(),
            this.activeDiv = this.activeDiv = 1;  
            this.downloadTemplateMessage = ''
        },
        submitFile() {
            try {
                this.$validator.validateAll("uploadform").then((result) => {
                    if (!result) {
                        this.$alert('Please Select File', "Validation Error", "error");
                    }  else {
                        // this.startUpload();
                        this.activeDiv = this.activeDiv === 1 ? 2 : 1;
                        this.startUploadTest()
                    }
                }).catch(() => {
                    console.log('errors exist');
                    return false;
                });                
            } catch (error) {
                console.log(error);
            }
        },        
        async createDropdowns(sheet, data, columnIndex) {
            const values = data.map(row => row[columnIndex].split(','));
            const uniqueValues = [...new Set(values.flat())];          
            // Add a dropdown for each cell in the last column
            for (let i = 2; i <= data.length + 1; i++) {
              const cellRef = `${XLSX.utils.encode_col(columnIndex)}${i}`;
              sheet.getCell(cellRef).dataValidation = {
                type: 'list',
                formula1: uniqueValues.join(','),
                showErrorMessage: true,
                errorTitle: 'Invalid value',
                error: 'Please select a value from the list',
              };
            }
          },
        async createTemplate() {
            try {
                this.isLoading = true
                let final_json_array = [];
                const wb = XLSX.utils.book_new();
                // Create new workbook
                let result = await TripServices.GetDepositListing(this.filterPaylod.input);
                this.totalCount = result.data.data.count
                if (result && result.data.code == 200 && result.data.data.count > 0) {
                    let toBeVerifiedData = result.data.data.rows.map(el => {
                        let depositstatus = ''
                        if (el.depositsstatus == 0) {
                            depositstatus = 'To be verified'
                        } else if (el.depositsstatus == 1) {
                            depositstatus = 'Accepted'
                        } else {
                            depositstatus = 'Rejected'
                        }
                        let wayBillNumber = el.awb != null ? el.awb.map(val => val.awb) : 'NA'
                        const insertedTimestampFromDB = el.lastmodifieddate
                        const insertedTimestamp = new Date(insertedTimestampFromDB);
                        const currentTime = new Date();
                        const elapsedMilliseconds = currentTime - insertedTimestamp;
                        const twentyFourHoursInMilliseconds = 24 * 60 * 60 * 1000;
                        if (elapsedMilliseconds >= twentyFourHoursInMilliseconds) {
                            // console.log("24 hours have passed since insertion.");
                            this.ftcapprovalLapsedTime = false
                        } else {
                            // console.log("Less than 24 hours have passed since insertion.");
                            this.ftcapprovalLapsedTime = true
                        }
                        let pendingVerificationData = {
                            'Cash Deposit ID': el.depositid,
                            "Destination Branch": el.hubid,
                            'WayBill No': wayBillNumber.toString(),
                            'Upload Date': moment().format('DD MMM YYYY HH:mm:ss'),
                            'WayBill Collectible Amount': el.ftcsettlementpendingamt,
                            'Deposit Amount': el.depositamount,
                            'Bank Name': el.bankname,
                            'Deposit Date': el.createddate,
                            'Deposit Status': depositstatus,
                            'Deposit by': el.depositby,
                            "Finance Review Status": "",
                            "Rejected Reason": ""
                        }
                        return pendingVerificationData;
                    })                    
                    if (toBeVerifiedData) {
                        final_json_array.push(...toBeVerifiedData);
                        const descendingSortedArray = [...final_json_array].sort((a, b) => b.id - a.id);
                        if (descendingSortedArray.length > 0) {
                            const sheet = XLSX.utils.json_to_sheet(descendingSortedArray);
                            XLSX.utils.book_append_sheet(wb, sheet, 'Finance Reviewed For Upload');
                            this.loader = false;
                            let xlsFileName = `Finance Reviewed For Upload_${moment().format('DDMMMYYYY_HH:mm:ss')}.xlsx`
                            XLSX.writeFile(wb, xlsFileName);
                            this.downloadTemplateMessage = `Template downloaded successfully. You can find it in your Downloads folder. Downloaded File name is ${xlsFileName} `
                            this.isLoading = false
                            return this.$alertify.success("Successfully Created Template File");
                        } else {
                            this.isLoading = false
                            return this.$alertify.error("All deposit slips are approved")
                        }
                    } else {
                        this.isLoading = false
                        return this.$alertify.error("Data Not Found")
                    }
                }
            } catch (error) {
                this.isLoading = false
                console.log("error", error);
            }
        },
        async startUpload() {
            try {
                this.disabled = true;
                this.$set(this.progressarr, 0 , 'start')
                this.isEditing= true;
                this.showSpinner= true;
                this.stepOne = await this.uploadFile(this.file)
                // this.stepOne = true
                // this.totaldata = 15
                // this.fileid = 15
                if (this.stepOne) {
                    let result;                    
                    this.$set(this.progressarr, 0 , 'complete')
                    this.$set(this.progressarr, 1 , 'start')
                    while (this.validateddata < this.totaldata) {
                        let norecord = this.limit
                        if (this.limit + this.offset > this.totaldata) {
                            norecord = this.totaldata - this.offset
                        }
                        result = await this.validate(this.fileid, norecord);
                    }
                    let tempData = this.groupBy(this.validdateddatalist, "status");
                    this.totalRecords = this.totaldata;
                    if (tempData[1]) {
                        this.successRecords = tempData[1];
                        this.validrecordsforimport = tempData[1].length;                     
                    }
                    if (tempData[0]) {
                        this.failedRecords = tempData[0];
                        this.invalidRecordCount = this.failedRecords ? this.failedRecords.length : 0
                    }
                    this.showresult = true;
                    this.stepTwo = true;
                    this.$set(this.progressarr, 1 , 'complete')
                    this.showSpinner = false
                    this.downloadTemplateMessage = ''
                }
            } catch (error) {
                console.log(error);
            }
        },
        async markStep1Done() {
            console.log("cehck");
            this.activeStep_2 = true
            this.activeStep_Zoom_1 = false
            this.activeStep_Zoom_2 = true
            this.activeStep_Zoom_3 = false
            this.activeStep_Zoom_4 = false
            this.stepText_1 = 'Shipment Validated',
            this.stepText_2 = 'Validating..',
            this.stepText_3 = 'Not Started',
                this.stepText_4 = 'Not Started'
                this.progressValue += 30;
        },
        async markStep2Done() {
            console.log("cehck");
            this.activeStep_3 = true
            this.activeStep_Zoom_1 = false
            this.activeStep_Zoom_2 = false
            this.activeStep_Zoom_3 = true
            this.activeStep_Zoom_4 = false
            this.stepText_1 = 'Completed',
            // this.stepText_2 = 'Completed',
            this.stepText_3 = 'Waiting For Action',
                this.stepText_4 = 'Not Started'
                this.progressValue += 10;
        },
        async markStep3Done() {
            this.activeStep_4 = true
            this.activeStep_Zoom_1 = false
            this.activeStep_Zoom_2 = false
            this.activeStep_Zoom_3 = false
            this.activeStep_Zoom_4 = true
            this.stepText_1 = 'Completed',
            // this.stepText_2 = 'Completed',
            this.stepText_3 = 'Deposit Approved',
            this.stepText_4 = 'Done'
            this.showOverlay = false
            this.progressValue += 40;
        },
        async resetToFirst() {
            this.activeStep_1 = true
            this.activeStep_2 = false
            this.activeStep_3 = false
            this.activeStep_4 = false
            this.activeStep_Zoom_1 = true
            this.activeStep_Zoom_2 = false
            this.activeStep_Zoom_3 = false
            this.activeStep_Zoom_4 = false
            this.stepText_1 = 'Processing',
            this.stepText_2 = 'Not Started',
            this.stepText_3 = 'Not Started',
                this.stepText_4 = 'Not Started'
            this.progressValue = 10
        },
        async startUploadTest() {
            try {
                this.disabled = true;
                this.$set(this.progressarr, 0 , 'start')
                this.isEditing= true;
                this.showSpinner= true;
                this.stepOne = await this.uploadFile(this.file)
                // this.stepOne = true
                // this.totaldata = 15
                // this.fileid = 15
                if (this.stepOne) {
                    let result;                  
                    this.markStep1Done()
                    this.$set(this.progressarr, 0 , 'complete')
                    this.$set(this.progressarr, 1 , 'start')
                    while (this.validateddata < this.totaldata) {
                        let norecord = this.limit
                        if (this.limit + this.offset > this.totaldata) {
                            norecord = this.totaldata - this.offset
                        }
                        result = await this.validate(this.fileid, norecord);
                    }
                    this.stepText_2 = `Validating - ${this.validateddata}  out of ${this.totaldata} records`
                    let tempData = this.groupBy(this.validdateddatalist, "status");
                    this.totalRecords = this.totaldata;
                    if (tempData[1]) {
                        this.successRecords = tempData[1];
                        this.validrecordsforimport = tempData[1].length;                     
                    }
                    if (tempData[0]) {
                        this.failedRecords = tempData[0];
                        this.invalidRecordCount = this.failedRecords ? this.failedRecords.length : 0
                    }
                    this.stepText_2 = `Valid - ${this.validrecordsforimport}  out of ${this.totaldata} records`
                    this.markStep2Done()
                    this.showresult = true;
                    this.stepTwo = true;
                    this.$set(this.progressarr, 1 , 'complete')
                    this.showSpinner = false
                }
            } catch (error) {
                console.log(error);
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/bulkreviewftcdeposit/bulkreviewftcdeposit.component.js